/**
 * Builds Hasura-style `where` for erpLaborTickets scoped to the current OperatorView machine.
 *
 * Non-MES uses machineRef or legacy resource link; MES with a configured laborResourceId also
 * matches by resourceId. Each path prefers the ticket top-level `machineRef`, and only falls
 * back to resource-linked rows when that field is null (`_is_null`), so legacy tickets with
 * different resource links still match.
 * Settings `laborResourceId` compares to ticket `resourceId` (erp.labor_ticket.resource_id).
 *
 * @param {Object} params
 * @param {number} params.machineRef - Callers should skip the query when missing when possible.
 * @param {boolean} params.isMesEnabled - company + machine MES (see getIsMESEnabled)
 * @param {string|null|undefined} params.laborResourceId - from machine settings
 * @returns {Object} erpLaborTickets_bool_exp fragment
 */

/** @param {number|string} machineRef */
function whereMachineRefOrLegacyResourceLink(machineRef) {
  return {
    _or: [
      { machineRef: { _eq: machineRef } },
      {
        _and: [
          { machineRef: { _is_null: true } },
          { resource: { machineRef: { _eq: machineRef } } },
        ],
      },
    ],
  };
}

/** @param {number|string} machineRef @param {string} laborResourceId */
function whereMachineRefOrLaborResourceLink(machineRef, laborResourceId) {
  return {
    _or: [
      { machineRef: { _eq: machineRef } },
      {
        _and: [
          { machineRef: { _is_null: true } },
          { resourceId: { _eq: laborResourceId } },
        ],
      },
    ],
  };
}

export function getLaborTicketWhereForMachine({
  machineRef,
  isMesEnabled,
  laborResourceId,
}) {
  if (!isMesEnabled) {
    return whereMachineRefOrLegacyResourceLink(machineRef);
  }

  if (laborResourceId != null && laborResourceId !== '') {
    return whereMachineRefOrLaborResourceLink(machineRef, laborResourceId);
  }

  return whereMachineRefOrLegacyResourceLink(machineRef);
}
